import { trackNavigationClick } from '@ecomm/cdp-tracking'
import { useCallback } from 'react'
import { useTracking } from 'react-tracking'

export const useTrackingFullHeader = () => {
  const tracking = useTracking()

  return useCallback(
    (track: boolean, showSideNav: boolean) => {
      if (track) {
        tracking.trackEvent({
          event: 'navigation-link',
          eventAction: showSideNav ? 'close' : 'open',
          eventCategory: 'navigation',
          label: 'hamburger'
        })
        trackNavigationClick({
          action: showSideNav ? 'close' : 'open',
          navElement: 'hamburger'
        })
      }
    },
    [tracking]
  )
}
